const configUrl = {
  showAllClasses: '/showbiz/api/seats',
  bookTickets: '/showbiz/api/booking'
};
export default configUrl;
